<template>
  <div
    v-if="isVisible"
    class="absolute shadow-lg rounded-sm border bg-EXPONDO-primary-5 text-EXPONDO-black z-10"
  >
    <span class="text-sm whitespace-nowrap p-2">{{ text }}</span>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CustomHint',
  props: {
    text: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
